import styled from "styled-components";

export const ShopExtPageTitle = styled.p`
  grid-column: 1/-1;
  font-size: 32px;
  line-height: 38px;
  color: #0a0000;
`;

export const ContentContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 10px;
  padding-bottom: 10px;
`;

export const InputFormContainer = styled.div`
  grid-column: 1/4;
`;

export const ButtonContainer = styled.div`
  display: flex;
  button {
    flex-grow: 1;
  }
`;
